const SuccessStatus = ({ message = "Operação realizada com sucesso" }) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            backgroundColor: '#d1fae5',
            color: '#065f46',
            borderRadius: '8px'
        }}>
            ✅
            <span>{message}</span>
        </div>
    );
}

export default SuccessStatus;